import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * FootballHubPage - Página simplificada que redireciona para a comunidade
 * 
 * Esta página foi simplificada para redirecionar automaticamente para /futebol/comunidade
 * O código original com gráficos foi preservado no Git (commit anterior)
 */

export default function FootballHubPage() {
  const navigate = useNavigate();
  
  // Redireciona automaticamente para a página de comunidade
  useEffect(() => {
    navigate('/futebol/comunidade', { replace: true });
  }, [navigate]);
  
  // Loading state enquanto redireciona
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#f3f2ef' }}>
      <div className="animate-spin w-12 h-12 border-4 border-t-[#111111] border-gray-200 rounded-full"></div>
    </div>
  );
}
